import BumpGroupGeneratorContainer from './BumpGroupGeneratorContainer';

export default BumpGroupGeneratorContainer;
